export const NpsThankyouAndSkipConfirmationData = {
  skipConfirmation: {
    heading: "CoFriends bisa bikin orangtua seneng, loh.",
    subheading: "Yakin ngasih nomornya nanti aja?",
    imageSrc: "/assets/nps/coco-sad.svg",
    buttonText: "Aku mau nyenengin ortu"
  },
  thankyouAfterSubmittingPhoneNumber: {
    heading: "Makasih, ya!",
    subheading: "Seneng deh kalo CoFriends ngerasa terbantu sama Kelas Live.",
    imageSrc: "/assets/nps/coco-and-cat.svg",
    buttonText: "Sip"
  },
  thankyouAfterSubmittingFeedback: {
    heading: "Makasih ya buat masukannya",
    subheading:
      "CoLearn akan perbaiki biar bisa bikin kelas yang lebih seru buat CoFriends.",
    imageSrc: "/assets/nps/my-activity.svg",
    buttonText: "Oke"
  }
};
